if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super()
    }

    connectedCallback () {
      this.openDefault = this.dataset.openDefault === 'true'

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false
        } else {
          this.open = true
        }
      })

      document.addEventListener('unmatchTablet', () => {
        this.open = true
      })
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' })
}

// Handle newsletter claim button click
document.addEventListener('DOMContentLoaded', function () {
  const claimButtons = document.querySelectorAll('.footer-newsletter__claim-btn')
  claimButtons.forEach(button => {
    button.addEventListener('click', function () {
      const formId = this.dataset.newsletterFormId
      if (formId) {
        const form = document.getElementById(formId)
        if (form) {
          const submitButton = form.querySelector('button[type="submit"]')
          if (submitButton) {
            submitButton.click()
          }
        }
      }
    })
  })
})